import { render, staticRenderFns } from "./PercentileBar.vue?vue&type=template&id=f9c5029a&"
import script from "./PercentileBar.vue?vue&type=script&lang=ts&"
export * from "./PercentileBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports